import { render, staticRenderFns } from "./MaterialBomPreivew.vue?vue&type=template&id=74cf88ea&"
import script from "./MaterialBomPreivew.vue?vue&type=script&lang=js&"
export * from "./MaterialBomPreivew.vue?vue&type=script&lang=js&"
import style0 from "./MaterialBomPreivew.vue?vue&type=style&index=0&id=74cf88ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports